/** Every Reporting panel the canvas can open, in rail order, by the short id the URL carries. `byMonth` panels read
 *  the monthly social report, so a window shows them as a notice offering Month. */
export const PANELS = [
  { id: "growth", title: "Rate of growth", group: "growth", byMonth: true },
  { id: "overview", title: "Overview", group: "social", byMonth: true },
  { id: "followers", title: "Followers", group: "social", byMonth: false },
  { id: "trends", title: "Performance Trends", group: "social", byMonth: true },
  { id: "booking", title: "Booking Intent", group: "social", byMonth: true },
  { id: "content", title: "Content Insights", group: "social", byMonth: true },
  { id: "profile", title: "Business Profile", group: "google", byMonth: false },
  { id: "website", title: "Website", group: "google", byMonth: false },
  { id: "metaads", title: "Ad performance", group: "paid", byMonth: false },
  { id: "googleads", title: "Google Ads", group: "paid", byMonth: false },
  { id: "facebook", title: "Facebook", group: "platforms", byMonth: true },
  { id: "instagram", title: "Instagram", group: "platforms", byMonth: true },
  { id: "tiktok", title: "TikTok", group: "platforms", byMonth: true },
] as const;

export type PanelId = (typeof PANELS)[number]["id"];
export type PanelGroup = (typeof PANELS)[number]["group"];

export const PANEL_GROUPS: ReadonlyArray<{ id: PanelGroup; label: string | null }> = [
  { id: "growth", label: null },
  { id: "social", label: "Social" },
  { id: "google", label: "Google" },
  { id: "paid", label: "Paid" },
  { id: "platforms", label: "By platform" },
];

/** The panels that read by month only, in rail order. */
export const BY_MONTH_PANELS: ReadonlyArray<PanelId> = PANELS.filter((p) => p.byMonth).map((p) => p.id);

/** What the canvas opens on with no layout in the URL. */
export const DEFAULT_PANEL: PanelId = "growth";

export const isPanelId = (value: string): value is PanelId => PANELS.some((p) => p.id === value);

export const panelTitle = (id: PanelId): string => PANELS.find((p) => p.id === id)?.title ?? id;
